module.exports = __webpack_public_path__ + "static/media/logo-leantech.68325d51.png";